export default __webpack_public_path__ + "static/media/crest_shadow_v2.c42f1dc0.png";